import { render, staticRenderFns } from "./rectifyTargetAdd.vue?vue&type=template&id=56d50428&scoped=true"
import script from "./rectifyTargetAdd.vue?vue&type=script&lang=js"
export * from "./rectifyTargetAdd.vue?vue&type=script&lang=js"
import style0 from "./rectifyTargetAdd.vue?vue&type=style&index=0&id=56d50428&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d50428",
  null
  
)

export default component.exports